import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FlameIcon, XIcon } from 'lucide-react';
import { OFFER_ANCHOR, purchaseAlerts } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        timeout = setTimeout(() => {
          setIndex(prev => (prev + 1) % purchaseAlerts.length);
          showNext();
        }, 6000);
      }, 6000);
    };
    timeout = setTimeout(showNext, 4000);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const alert = purchaseAlerts[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-134" data-mp="164eigf4ahqmw">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 w-[min(18rem,calc(100vw-1.5rem))]" data-id="element-135" data-mp="117fqo383lvrv">
          <div className="relative flex items-start gap-2.5 rounded-xl border-2 border-gold bg-carbon-soft p-2.5 pr-7 shadow-[0_10px_30px_rgba(0,0,0,0.55)]" data-id="element-136" data-mp="i81tlcf2o4x5">
            <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-coral" data-id="element-137" data-mp="x6vv3436b07u">
              <FlameIcon size={18} className="text-cream" strokeWidth={2.5} data-id="element-138" data-mp="s4wpdnjynr7q" />
            </span>
            <div className="min-w-0" data-id="element-139" data-mp="28iwq30qmrkw1">
              <p className="text-[0.78rem] font-extrabold leading-tight text-cream" data-id="element-140" data-mp="23ld6rmf2shx8">
                {alert.name}
              </p>
              <p className="text-[0.68rem] leading-tight text-beige" data-id="element-141" data-mp="2anjine02s56r">
                {alert.city}, {alert.country}
              </p>
              <a href={OFFER_ANCHOR} className="mt-0.5 block text-[0.7rem] font-bold uppercase leading-tight text-gold underline underline-offset-2" data-id="element-142" data-mp="2fltgjwd6pjw2">
                Acabó de comprar este libro digital
              </a>
              <p className="text-[0.62rem] uppercase tracking-wide text-muted" data-id="element-143" data-mp="1rz4quohxon4w">
                Hace {minutes} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-1.5 top-1.5 text-muted transition-colors duration-150 ease-soft hover:text-cream" data-id="element-144" data-mp="1wutyzg80rcct">
              <XIcon size={14} data-id="element-145" data-mp="195hpef8s529z" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}